import { Document } from '../../../models';


type TarmedContractProps = {
    membershipId: string;
    crmDocuments: Document[] | undefined;
};

export const TardocContract = ({ membershipId, crmDocuments }: TarmedContractProps) => {


    return (
        <>
            <p>
                Bitte treten Sie dafür den Tarifverträgen für TARDOC und Ambulante Pauschalen über 
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://tarifeambulant.fmh.ch/organisation/vertraege.cfm"
                > myFMH </a>bei. Aktuell ist der Beitritt zu den nationalen Tarifstrukturverträgen möglich. Sobald der Betritt zum kantonalen Tarifvertrag Zürich möglich ist, wird die AGZ Sie informieren.
            </p>
        </>
    );
};
